import * as React from "react";
import PieChart from "@cloudscape-design/components/pie-chart";
import Box from "@cloudscape-design/components/box";
import { TyreTable } from "./data list tyre/data";

interface DataItem {
  title: string;
  percentage: number;
  value: number;
}

interface BatteryItem {
  tyres: TyreTable[]; // Array of tyres with battery percentage
}

const Battery: React.FC<BatteryItem> = ({ tyres }) => {
  // Generate battery data from tyres
  const batteryData = tyres.map((tyre) => ({
    id: tyre.id,
    battery: tyre.battery, 
 
    // Battery percentage
  }));
  console.log(batteryData);
  // Function to categorize batteries
  const categorizeBatteries = (batteries: { battery: number }[]): DataItem[] => {
    const categoryCount = { OK: 0, Warning: 0, Attention: 0 };

    batteries.forEach((_battery) => {
      if (_battery.battery > 70 && _battery.battery <= 100) {
        categoryCount.OK += 1;
      } else if (_battery.battery >= 30 && _battery.battery < 70) {
        categoryCount.Warning += 1;
      } else if (_battery.battery < 30) {
        categoryCount.Attention += 1;
      }
    });

    const total = batteries.length;

    // Calculating percentages for each category
    return [
      {
        title: "OK",
        value: categoryCount.OK,
        percentage: (categoryCount.OK / total) * 100,
      },
      {
        title: "Warning",
        value: categoryCount.Warning,
        percentage: (categoryCount.Warning / total) * 100,
      },
      {
        title: "Attention",
        value: categoryCount.Attention,
        percentage: (categoryCount.Attention / total) * 100,
      },
    ];
  };

  // Process battery data to get categorized data for the pie chart
  const pieChartData = categorizeBatteries(batteryData);

  return (
    <div style={{ textAlign: "center" }}>
      <h3 style={{ marginTop: "0px" }}>Battery Status</h3>
      <PieChart
        data={pieChartData}
        ariaDescription="Pie chart showing battery health statuses."
        ariaLabel="Battery Status Pie Chart"
        size="small"
        innerMetricDescription="Total Batteries"
        innerMetricValue={batteryData.length.toString()}
        empty={
          <Box textAlign="center" color="inherit">
            <b>No data available</b>
            <Box variant="p" color="inherit">
              There is no data available
            </Box>
          </Box>
        }
        noMatch={
          <Box textAlign="center" color="inherit">
            <b>No matching data</b>
            <Box variant="p" color="inherit">
              There is no matching data to display
            </Box>
          </Box>
        }
      />
    </div>
  );
};

export default Battery;
